import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { ProjectInfoMenuButton, ProjectInfoMenuContent } from './components'
import { useProjectInfo } from './useProjectInfo'

export const ProjectInfoMenu: React.FC = () => {
  const { onClick } = useProjectInfo()

  return (
    <DropdownMenu.Root
      align="end"
      onClick={onClick}
      content={ProjectInfoMenuContent}
    >
      <ProjectInfoMenuButton />
    </DropdownMenu.Root>
  )
}
